// import React, { useState } from 'react';
// import Breadcrumb from '../../components/Breadcrumb';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const categories = [
//   { title: 'Clinical Research & Education' },
//   { title: 'Fellowship Programs' },
//   { title: 'House Job / Internship Programs' },
//   { title: 'CME Activities' },
//   { title: 'Research Publications' },
//   { title: 'Conferences & Workshops' },
//   { title: 'Institutional Review Board (IRB)' },
// ];

// const tenders = [
//   { title: 'Current Tenders' },
//   { title: 'Past Tender Results' },
//   { title: 'Procurement Policy' },
//   { title: 'Vendor Registration Guidelines' },
// ];

// const itServices = [
//   { title: 'HMIS Overview' },
//   { title: 'PACS / RIS Info' },
//   { title: 'Digital Library Access' },
//   { title: 'Network Infrastructure Overview' },
//   { title: 'Integrated Surveillance System (upcoming, if relevant)' },
// ];

// const MedicalMain = () => {
//   const [activeModal, setActiveModal] = useState(null);

//   const openModal = (title) => setActiveModal(title);
//   const closeModal = () => setActiveModal(null);

//   const getCustomParagraph = (title) => {
//   switch (title) {
//     case 'Clinical Research & Education':
//       return (
//         <>
//           <p>
//             At the heart of medical advancement lies <strong>clinical research and education</strong>.
//             Our institution is dedicated to fostering a culture of continuous learning, scientific
//             inquiry, and innovation. Through structured educational programs, hands-on research
//             opportunities, and collaborative initiatives, we empower healthcare professionals and
//             students to explore new frontiers in medicine.
//           </p>
//           <p>
//             Whether you're a student, clinician, or researcher, our goal is to equip you with the
//             knowledge, skills, and ethical grounding needed to transform patient care and contribute to
//             the future of healthcare.
//           </p>
//         </>
//       );
//     case 'Fellowship Programs':
//       return (
//         <>
//           <p>
//             Our Fellowship Programs are designed to offer advanced, specialized training for medical professionals
//             who wish to deepen their expertise in a specific field. Through mentorship, hands-on clinical exposure,
//             and academic enrichment, fellows gain the skills and knowledge necessary to become leaders in their
//             specialties. These programs bridge the gap between residency and independent practice, fostering
//             professional growth and excellence in patient care.
//           </p>
//         </>
//       );
//         case 'House Job / Internship Programs':
//         return (
//             <>
//             <p>
//                 Our <strong>House Job and Internship Programs</strong> provide essential hands-on experience for newly graduated medical professionals.
//                 These structured programs are designed to bridge the gap between academic education and real-world clinical practice, offering exposure
//                 to various departments, patient care responsibilities, and inter-professional teamwork.
//             </p>
//             <p>
//                 Interns and house officers are mentored by experienced physicians and healthcare staff, ensuring the development of practical skills,
//                 professional confidence, and ethical decision-making. These programs serve as a critical stepping stone toward residency and long-term
//                 medical careers.
//             </p>
//             </>
//         );
//     case 'CME Activities':
//     return (
//       <>
//         <p>
//           Our <strong>Continuing Medical Education (CME) Activities</strong> are dedicated to fostering lifelong learning and professional development
//           for healthcare providers. Through regular workshops, seminars, and accredited courses, we ensure that medical professionals stay up-to-date
//           with the latest clinical practices, research, and technological advancements.
//         </p>
//         <p>
//           These CME initiatives are designed to enhance clinical competence, improve patient outcomes, and promote a culture of continuous improvement
//           in the healthcare system. Participation in CME not only fulfills licensing requirements but also reflects a commitment to excellence in patient care.
//         </p>
//       </>
//     );
//     case 'Research Publications':
//   return (
//     <>
//       <p>
//         <strong>Research Publications</strong> reflect our institution’s ongoing commitment to evidence-based medicine and academic excellence. Our faculty,
//         researchers, and students actively contribute to scientific literature through peer-reviewed journals, case studies, and clinical trials.
//       </p>
//       <p>
//         These publications not only highlight our innovative research efforts but also serve as valuable resources for the global medical community.
//         We encourage interdisciplinary collaboration and strive to publish research that drives meaningful improvements in patient care and public health.
//       </p>
//     </>
//   );
// case 'Conferences & Workshops':
//   return (
//     <>
//       <p>
//         Our <strong>Conferences & Workshops</strong> provide interactive platforms for knowledge exchange, skill development, and networking among medical professionals.
//         Hosted regularly, these events feature leading experts, latest research trends, and hands-on learning experiences tailored to diverse medical specialties.
//       </p>
//       <p>
//         Whether you're looking to deepen your expertise or stay current with medical innovations, our events support your growth and enhance
//         collaborative learning within the healthcare community.
//       </p>
//     </>
//   );
// case 'Institutional Review Board (IRB)':
//   return (
//     <>
//       <p>
//         The <strong>Institutional Review Board (IRB)</strong> serves as the ethical backbone of our research environment, ensuring that all studies involving human
//         subjects are conducted responsibly and in accordance with national and international standards.
//       </p>
//       <p>
//         The IRB reviews research proposals for compliance with ethical principles, prioritizing the safety, rights, and welfare of participants.
//         Our goal is to foster innovative research while maintaining the highest standards of ethical integrity and transparency.
//       </p>
//     </>
//   );
// case 'Current Tenders':
//   return (
//     <>
//       <p>
//         Our <strong>Current Tenders</strong> section lists all active procurement opportunities within the institution.
//         This ensures transparency and encourages qualified vendors and contractors to participate in competitive bidding.
//       </p>
//       <p>
//         Regular updates are provided to keep stakeholders informed about new projects, supply needs, and service contracts.
//       </p>
//     </>
//   );

// case 'Past Tender Results':
//   return (
//     <>
//       <p>
//         The <strong>Past Tender Results</strong> archive offers detailed records of completed procurement processes.
//         This includes awarded contracts, bidding summaries, and evaluation criteria to maintain accountability and public trust.
//       </p>
//       <p>
//         Reviewing past results can help vendors improve future submissions and understand our procurement standards.
//       </p>
//     </>
//   );

// case 'Procurement Policy':
//   return (
//     <>
//       <p>
//         Our <strong>Procurement Policy</strong> outlines the principles, procedures, and ethical guidelines governing all purchasing activities.
//         It ensures fair competition, cost-effectiveness, and compliance with legal requirements.
//       </p>
//       <p>
//         Adherence to this policy is essential for maintaining institutional integrity and optimizing resource utilization.
//       </p>
//     </>
//   );

// case 'Vendor Registration Guidelines':
//   return (
//     <>
//       <p>
//         The <strong>Vendor Registration Guidelines</strong> provide step-by-step instructions for prospective suppliers to register with our institution.
//         Proper registration enables vendors to participate in tenders, receive procurement notifications, and establish trusted partnerships.
//       </p>
//       <p>
//         Vendors are encouraged to follow these guidelines carefully to ensure their eligibility and smooth onboarding.
//       </p>
//     </>
//   );
//   case 'HMIS Overview':
//   return (
//     <>
//       <p>
//         The <strong>Health Management Information System (HMIS) Overview</strong> details our digital platform for managing clinical and administrative healthcare data.
//         HMIS facilitates efficient patient record management, reporting, and decision-making processes across departments.
//       </p>
//       <p>
//         This system supports improved healthcare delivery by integrating data flow and enhancing accessibility for authorized users.
//       </p>
//     </>
//   );

// case 'PACS / RIS Info':
//   return (
//     <>
//       <p>
//         Our <strong>Picture Archiving and Communication System (PACS)</strong> and <strong>Radiology Information System (RIS)</strong> are critical tools
//         for managing medical imaging workflows and radiology data.
//       </p>
//       <p>
//         These systems enable secure storage, retrieval, and sharing of diagnostic images, improving clinical collaboration and patient outcomes.
//       </p>
//     </>
//   );

// case 'Digital Library Access':
//   return (
//     <>
//       <p>
//         The <strong>Digital Library Access</strong> offers healthcare professionals and students 24/7 access to a vast repository of medical journals,
//         e-books, research databases, and educational materials.
//       </p>
//       <p>
//         Our digital library supports lifelong learning and evidence-based practice through curated, up-to-date resources.
//       </p>
//     </>
//   );

// case 'Network Infrastructure Overview':
//   return (
//     <>
//       <p>
//         The <strong>Network Infrastructure Overview</strong> describes the robust, secure communication backbone that supports all IT services within our institution.
//       </p>
//       <p>
//         This includes wired and wireless connectivity, data centers, security protocols, and disaster recovery plans ensuring reliable and safe operations.
//       </p>
//     </>
//   );

// case 'Integrated Surveillance System (upcoming, if relevant)':
//   return (
//     <>
//       <p>
//         Our <strong>Integrated Surveillance System</strong> is an upcoming initiative aimed at enhancing hospital security and patient safety.
//         By combining real-time monitoring, analytics, and automated alerts, this system will proactively manage risks and emergencies.
//       </p>
//       <p>
//         Stay tuned for updates as we implement this cutting-edge technology to strengthen our healthcare environment.
//       </p>
//     </>
//   );

//     default:
//       return (
//         <>
//           <p>
//             <strong>{title}</strong> is a vital aspect of our commitment to excellence. This section offers insight into
//             programs, policies, and innovations that are driving forward quality healthcare, research, and education.
//           </p>
//           <p>
//             Please explore more details and downloadable resources associated with <strong>{title}</strong> on our
//             official portals or through administrative contacts.
//           </p>
//         </>
//       );
//   }
// };

//   const renderButtons = (data) =>
//     data.map((item) => (
//       <div className="col-md-4 mb-4" key={item.title}>
//         <button className="category-btn shadow-sm" onClick={() => openModal(item.title)}>
//           {item.title}
//         </button>
//       </div>
//     ));

//   return (
//     <main>
//       <Breadcrumb title="Medical Education" />

//       <style>{`
//         .intro-text {
//           font-size: 17px;
//           color: #333;
//           line-height: 1.8;
//           margin-bottom: 30px;
//           text-align: justify;
//         }

//         .category-btn {
//           background: linear-gradient(135deg, #ee344e, #a52a2a);
//           color: white;
//           border: none;
//           width: 100%;
//           padding: 15px 20px;
//           border-radius: 35px;
//           font-weight: 600;
//           font-size: 16px;
//           transition: all 0.3s ease;
//           box-shadow: 0 5px 20px rgba(128, 0, 0, 0.3);
//         }
//         .category-btn:hover {
//           background: linear-gradient(135deg, #a40000, #cc0000);
//           transform: translateY(-3px);
//         }

//         .custom-modal {
//           position: fixed;
//           top: 50%;
//           left: 50%;
//           width: 90%;
//           max-width: 600px;
//           transform: translate(-50%, -50%);
//           background: #fff;
//           z-index: 1050;
//           box-shadow: 0 10px 40px rgba(0,0,0,0.4);
//           border-radius: 16px;
//           overflow: hidden;
//           animation: fadeInScale 0.3s ease;
//         }

//         @keyframes fadeInScale {
//           0% {
//             transform: translate(-50%, -50%) scale(0.9);
//             opacity: 0;
//           }
//           100% {
//             transform: translate(-50%, -50%) scale(1);
//             opacity: 1;
//           }
//         }

//         .modal-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100vw;
//           height: 100vh;
//           background: rgba(0,0,0,0.5);
//           z-index: 1040;
//         }

//         .modal-header {
//           padding: 20px;
//           background: linear-gradient(135deg, #ee344e, #a52a2a);
//           color: white;
//           font-size: 18px;
//           font-weight: bold;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .modal-body {
//           padding: 25px;
//           font-size: 16px;
//           color: #333;
//           background: #fff;
//         }

//         .modal-footer {
//           padding: 16px 24px;
//           display: flex;
//           justify-content: flex-end;
//           gap: 10px;
//           background: #f9f9f9;
//           border-top: 1px solid #ddd;
//         }

//         .close-btn {
//           background: transparent;
//           border: none;
//           font-size: 26px;
//           color: white;
//           cursor: pointer;
//         }
//       `}</style>

//       <section className="container my-5">
//         <h2 className="mb-4 text-center text-danger">Medical Education</h2>
//         <p className="intro-text">
//           Medical education serves as the foundation for shaping tomorrow's healthcare leaders. At our institute,
//           we are dedicated to providing high-quality, research-driven learning environments that empower students,
//           interns, and seasoned professionals. From hands-on clinical training to cutting-edge academic programs,
//           our mission is to foster excellence in patient care and medical innovation.
//         </p>

//         <div className="row">{renderButtons(categories)}</div>

//         <h3 className="my-5 text-danger">Tenders & Procurement</h3>
//         <div className="row">{renderButtons(tenders)}</div>

//         <h3 className="my-5 text-danger">IT & Digital Services</h3>
//         <div className="row">{renderButtons(itServices)}</div>
//       </section>

//       {activeModal && (
//         <>
//           <div className="modal-overlay" onClick={closeModal}></div>
//           <div className="custom-modal">
//             <div className="modal-header">
//               <span>{activeModal}</span>
//               <button className="close-btn" onClick={closeModal}>&times;</button>
//             </div>
//             <div className="modal-body">
//               {getCustomParagraph(activeModal)}
//             </div>
//             <div className="modal-footer">
//               <button className="btn btn-outline-danger" onClick={closeModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </>
//       )}
//     </main>
//   );
// };

// export default MedicalMain;



/*
  Medical Education Department - Rawalpindi Institute of Cardiology
  React component (modern, expandable categories + modal details + animations + color accents).

  REQUIREMENTS:
  - Add Bootstrap CSS and JS to your React project.
    public/index.html should include:
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
*/

/*
  Medical Education Department - Rawalpindi Institute of Cardiology
  React component (full-width, modern, expandable categories + modal details + animations + color accents).

  REQUIREMENTS:
  - Add Bootstrap CSS and JS to your React project.
    public/index.html should include:
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
*/

/*
  Medical Education Department - Rawalpindi Institute of Cardiology
  React component (full-width, modern, expandable categories + modal details + animations).

  REQUIREMENTS:
  - Add Bootstrap CSS and JS to your React project.
    public/index.html should include:
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
*/

// updated CSS styling Code


// import React, { useState } from 'react';
// import { BookOpen, Target, Award, GraduationCap, Phone, ChevronDown, Layers, CheckCircle, Users, ClipboardList } from 'lucide-react';

// export default function MedicalEducation() {
//   const [modalContent, setModalContent] = useState({ title: '', body: '' });
//   const [expanded, setExpanded] = useState(null);

//   const openModal = (title, body) => {
//     setModalContent({ title, body });
//     const modal = new window.bootstrap.Modal(document.getElementById('infoModal'));
//     modal.show();
//   };

//   const toggleExpand = (category) => {
//     setExpanded(expanded === category ? null : category);
//   };

//  const programStructure = {
//   MS: {
//     description:
//       "Master of Surgery (MS) programs focus on developing advanced surgical expertise through rigorous clinical training and hands-on operative exposure.",
//     items: [
//       { title: 'Cardiac Surgery', body: 'Residents learn to perform complex surgeries such as bypass grafting and valve replacement to correct severe cardiac issues.' },
//       { title: 'Anaesthesia', body: 'Residents develop a strong foundation in providing safe and effective anesthesia care across a broad range of specialties.' }
//     ]
//   },
//   MD: {
//     description:
//       "Doctor of Medicine (MD) programs provide specialized training in clinical fields to prepare physicians for academic, clinical, and research leadership.",
//     items: [
//       { title: 'Cardiology', body: 'Residents are trained to manage a wide spectrum of cardiovascular conditions, from heart failure to arrhythmias. RIC has developed four Cardiology units.' },
//       { title: 'Pediatric Cardiology', body: 'Residents are trained to handle the unique challenges of treating young patients with congenital and acquired cardiac anomalies.' }
//     ]
//   },
//   Diploma: {
//     description:
//       "Diploma programs are designed to provide focused and practical training in specific medical specialties, ensuring competency in applied clinical practice.",
//     items: [
//       { title: 'Anaesthesia', body: 'Diploma program in Anaesthesia focusing on safe administration and perioperative care.' },
//       { title: 'Cardiology', body: 'Diploma program in Cardiology focusing on clinical and diagnostic training.' }
//     ]
//   },
//   FCPS: {
//     description:
//       "The Fellowship of College of Physicians and Surgeons (FCPS) program offers structured and comprehensive training across multiple disciplines of medicine and surgery.",
//     items: [
//       { title: 'Cardiology', body: 'Training in diagnosis and management of heart diseases.' },
//       { title: 'Cardiac Surgery', body: 'Training in operative procedures on the heart and vessels.' },
//       { title: 'Interventional Cardiology', body: 'Hands-on experience in angioplasty, stenting, and catheter-based procedures.' },
//       { title: 'Radiology', body: 'Training in imaging interpretation (X-rays, CT, MRI) for cardiac conditions.' },
//       { title: 'Pediatric Cardiology', body: 'Specialized training for infants and children with heart diseases.' },
//       { title: 'Pediatric Congenital Cardiac Surgery', body: 'Surgical repair of congenital cardiac anomalies in pediatric patients.' },
//       { title: 'Anaesthesia', body: 'Safe and effective anesthesia training for cardiac procedures.' }
//     ]
//   },
//   MCPS: {
//     description:
//       "Membership of College of Physicians and Surgeons (MCPS) provides focused training in core specialties, preparing residents for independent practice and professional growth.",
//     items: [
//       { title: 'Anaesthesia', body: 'Focused training program in anesthesia for medical procedures and surgeries.' }
//     ]
//   }
// };

// const categoryIcons = {
//   MS: <Layers size={22} className="me-2 text-primary" />,
//   MD: <Layers size={22} className="me-2 text-success" />,
//   Diploma: <Layers size={22} className="me-2 text-warning" />,
//   FCPS: <Layers size={22} className="me-2 text-danger" />,
//   MCPS: <Layers size={22} className="me-2 text-purple" />
// };


//   return (
//     <div className="medical-ed-page">
//       {/* Hero Section */}
//       <section className="hero text-center">
//         <div className="container">
//           <h1 className="display-4 fw-bold text-white mb-3">Department of Medical Education</h1>
//           <p className="lead text-light">Rawalpindi Institute of Cardiology (RIC)</p>
//           <p className="text-light mx-auto" style={{ maxWidth: '720px' }}>
//             Strengthening healthcare education, training future medical professionals, and ensuring quality assurance in academic activities.
//           </p>
//         </div>
//       </section>

//       <div className="container my-5">
//     {/* About / Mission / Objectives / Vision */}
// <section className="row g-4 py-4">
//   {/* About Us */}
//   <div className="col-lg-6 col-md-12">
//     <div className="info-card p-4 h-100 shadow-lg text-center">
//       <div className="icon-circle gradient-blue mx-auto mb-3">
//         <BookOpen size={22} className="text-white" />
//       </div>
//       <h5 className="fw-bold mb-3">About Us</h5>
//       <p className="small text-dark fw-semibold">
//         The Medical Education Department at Rawalpindi Institute of Cardiology (RIC) plays a vital role in strengthening healthcare education, training future medical professionals, and ensuring quality assurance in academic activities. 
//         The institute envisions expanding its teaching portfolio by incorporating artificial intelligence (AI), data science, and digital health platforms into its curriculum. 
//         By training young professionals in AI-assisted diagnostic tools, machine learning models for risk stratification, and simulation-based learning, Department of Medical Education ensures that future cardiologists are well-prepared for the rapidly evolving landscape of cardiovascular medicine and surgery.
//       </p>
//     </div>
//   </div>

//     {/* Vision */}
//   <div className="col-lg-6 col-md-12">
//     <div className="info-card p-4 h-100 shadow-lg text-center">
//       <div className="icon-circle gradient-purple mx-auto mb-3">
//         <i className="bi bi-eye-fill text-white"></i>
//       </div>
//       <h5 className="fw-bold mb-3">Our Vision</h5>
//       <p className="small text-dark fw-semibold">
//         “The vision of the Department of Medical Education at RIC is to be a leader in medical education, 
//         recognized for its commitment to academic excellence, innovation (AI linked), 
//         and the development of compassionate healthcare professionals.”
//       </p>
//     </div>
//   </div>

//   {/* Mission & Philosophy */}
//   <div className="col-lg-6 col-md-12">
//     <div className="info-card p-4 h-100 shadow-lg text-center">
//       <Target size={40} className="text-success mb-3" />
//       <h5 className="fw-bold mb-3">Mission & Philosophy</h5>
//       <div className="advanced-list">
//         {[
//           "Dissemination of clinical knowledge",
//           "Evidence-based education",
//           "Highly skilled professionals",
//           "National & international standards",
//         ].map((item, i) => (
//           <div key={i} className="list-item d-flex align-items-center mb-3">
//             <span className="icon-circle gradient-green me-3">
//               <i className="bi bi-check-lg text-white"></i>
//             </span>
//             <span className="small text-dark fw-semibold">{item}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>

//   {/* Objectives */}
//   <div className="col-lg-6 col-md-12">
//     <div className="info-card p-4 h-100 shadow-lg text-center">
//       <Award size={40} className="text-warning mb-3" />
//       <h5 className="fw-bold mb-3">Objectives</h5>
//       <div className="advanced-list">
//         {[
//           "Structured postgraduate training",
//           "Continuous medical education",
//           "Promote research & innovation",
//           "Compliance with standards",
//         ].map((item, i) => (
//           <div key={i} className="list-item d-flex align-items-center mb-3">
//             <span className="icon-circle gradient-gold me-3">
//               <i className="bi bi-star-fill text-white"></i>
//             </span>
//             <span className="small text-dark fw-semibold">{item}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>


// </section>


//         {/* Key Features */}
//         <section className="py-5">
//           <h2 className="fw-bold text-center mb-4">Key Features</h2>
//           <ul className="list-unstyled row g-3">
//             {[
//               'Postgraduate Training Structure – FCPS, MD, MS, MCPS, and Diploma programs across cardiology and allied specialties.',
//               'Selection Criteria – Induction through Central Induction Program (CIP/PRP).',
//               'Academic SOPs – Daily sessions, bedside teaching, journal clubs, CPCs, and internal assessments.',
//               'Supervisor Responsibilities – Mentorship, training oversight, and research guidance.',
//               'Assessment & Appraisal – Six-monthly appraisals, feedback, and final evaluations.',
//               'Research Requirements – Synopsis, dissertation, and mandatory publications (as per CPSP/UHS).',
//               'Leave & Dress Code Policy – Defined under SHC&ME and institutional rules.',
//               'Experience Certification – Issued upon successful completion of training and academic requirements.'
//             ].map((feature, i) => (
//               <li key={i} className="col-md-6 d-flex align-items-start">
//                 <CheckCircle className="text-success me-2" size={20} /> <span>{feature}</span>
//               </li>
//             ))}
//           </ul>
//         </section>

//         {/* Our Team */}
//         <section className="py-5">
//           <h2 className="fw-bold text-center mb-4">Our Team</h2>
//           <div className="row g-4">
//             <div className="col-md-4">
//               <div className="info-card p-4 h-100 shadow-lg text-center">
//                 <Users size={36} className="text-primary mb-2" />
//                 <h6 className="fw-bold">Director / HOD Medical Education</h6>
//                 <p className="small text-muted mb-0">Dr. Kashif Rauf</p>
//               </div>
//             </div>
//             <div className="col-md-4">
//               <div className="info-card p-4 h-100 shadow-lg text-center">
//                 <Users size={36} className="text-success mb-2" />
//                 <h6 className="fw-bold">Supervisors & Faculty Members</h6>
//                 <p className="small text-muted mb-0">Professors, Associate Professors, Assistant Professors</p>
//               </div>
//             </div>
//             <div className="col-md-4">
//               <div className="info-card p-4 h-100 shadow-lg text-center">
//                 <Users size={36} className="text-warning mb-2" />
//                 <h6 className="fw-bold">Support Staff</h6>
//                 <p className="small text-muted mb-0">DEO, Junior DEO, Stenographer, Projector Operator, PA/Runner</p>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Postgraduate Training */}
//         <section className="py-5">
//           <h2 className="fw-bold text-center mb-4">Postgraduate Training</h2>
//           <ul className="list-unstyled">
//             {[
//               'Induction via Central Induction Program (CIP/PRP) of SHC&ME.',
//               'Regular academic sessions, CPCs, workshops, bedside teaching.',
//               'Six-monthly appraisal sessions with feedback & performance evaluation.',
//               'Research requirements: Synopsis, Dissertation, Article Publications.',
//               'Experience certificate issued upon completion as per CPSP/UHS policies.'
//             ].map((item, i) => (
//               <li key={i} className="d-flex align-items-start mb-2">
//                 <ClipboardList className="text-danger me-2" size={20} /> <span>{item}</span>
//               </li>
//             ))}
//           </ul>
//         </section>

//         {/* Expandable Programs */}
//         <section className="py-5">
//           <h2 className="fw-bold text-center mb-5 pb-5">Programs Offered</h2>
//           <div className="row g-4 mt-5 pt-5">
//             {Object.keys(programStructure).map((category, idx) => (
//               <div key={idx} className="col-lg-6 col-md-12">
//                 <div
//                   className={`expand-card p-4 shadow-lg ${expanded === category ? 'active' : ''}`}
//                   onClick={() => toggleExpand(category)}
//                 >
//                   <div className="d-flex justify-content-between align-items-center">
//                     <h4 className="fw-bold mb-0">{categoryIcons[category]}{category}</h4>
//                     <ChevronDown className={`chevron ${expanded === category ? 'rotate' : ''}`} />
//                   </div>
//                   <div className={`expand-content ${expanded === category ? 'show' : ''}`}>
//                     {/* Show description first */}
// <p className="small text-muted mb-3">
//   {programStructure[category].description}
// </p>
//                    {/* Show items */}
// {programStructure[category].items.map((item, i) => (
//   <div
//     key={i}
//     className="sub-item py-2 px-3 mb-2 rounded"
//     onClick={(e) => {
//       e.stopPropagation();
//       openModal(item.title, item.body);
//     }}
//   >
//     <GraduationCap size={18} className="me-2 text-secondary" /> {item.title}
//   </div>
// ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>
//       </div>

//       {/* Contact - Full Width */}
//       <section className="text-center py-5 contact-section">
//         <div className="container">
//           <Phone size={48} className="text-primary mb-3" />
//           <h4 className="fw-bold">Contact Us</h4>
//           <p className="mb-1">Medical Education Department, Rawalpindi Institute of Cardiology</p>
//           <p className="mb-1">Phone: 0519281374</p>
//           <p className="mb-0">Email: amsmedicaleducation@gmail.com</p>
//         </div>
//       </section>

//       {/* Modal */}
//       <div className="modal fade" id="infoModal" tabIndex="-1" aria-hidden="true">
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content modern-modal p-4">
//             <div className="modal-header border-0">
//               <h5 className="modal-title fw-bold">{modalContent.title}</h5>
//             </div>
//             <div className="modal-body">
//               {modalContent.body.split('\n').map((line, i) => (
//                 <p key={i} className="mb-2 text-muted">{line}</p>
//               ))}
//             </div>
//             <div className="modal-footer border-0">
//               <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Inline CSS */}
//       <style>{`
//         body, html, .medical-ed-page { margin: 0; padding: 0; width: 100%; overflow-x: hidden; }
//         .hero { background: linear-gradient(135deg, #ff2f00, #00d4ff); padding: 5rem 2rem; }
//         .info-card { border-radius: 16px; background: #fff; transition: all .3s ease; }
//         .info-card:hover { transform: translateY(-6px); box-shadow: 0 12px 24px rgba(0,0,0,.12); }
//         .expand-card { border-radius: 16px; transition: all .4s ease; cursor: pointer; overflow: hidden; background: #fff; }
//         .expand-card:hover { transform: translateY(-6px) scale(1.02); box-shadow: 0 12px 24px rgba(0,0,0,.2); }
//         .expand-card.active { border: 2px solid #007bff; }
//         .expand-content { max-height: 0; opacity: 0; overflow: hidden; transition: max-height .6s ease, opacity .6s ease; }
//         .expand-content.show { max-height: 600px; opacity: 1; margin-top: 1rem; }
//         .sub-item { background: #f8f9fa; font-size: 0.95rem; cursor: pointer; transition: background .2s, transform .2s; display: flex; align-items: center; color: #000; }
//         .sub-item:hover { background: #e9ecef; transform: translateX(4px); }
//         .chevron { transition: transform .3s ease; }
//         .chevron.rotate { transform: rotate(180deg); }
//         .contact-section { background: #ccf0ff7d; width: 100%; }
//         .modern-modal { border-radius: 20px; box-shadow: 0 12px 30px rgba(0,0,0,0.15); max-width: 400px; margin: auto; }
//        .icon-circle {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           width: 28px;
//           height: 28px;
//           border-radius: 50%;
//           flex-shrink: 0;
//           box-shadow: 0 3px 6px rgba(0,0,0,0.15);
//           transition: transform 0.2s ease, box-shadow 0.2s ease;
//         }
//         .icon-circle:hover {
//           transform: scale(1.1);
//           box-shadow: 0 6px 12px rgba(0,0,0,0.25);
//         }
//         .gradient-green {
//           background: linear-gradient(135deg, #28a745, #5ddc75);
//         }
//         .gradient-gold {
//           background: linear-gradient(135deg, #f5b700, #ffdd57);
//         }
//         .list-item .small {
//           font-size: 0.92rem;
//           line-height: 1.4;
//         }
//         .gradient-blue {
//           background: linear-gradient(135deg, #007bff, #00d4ff);
//         }
//         .info-card {
//           border-radius: 16px;
//           background: #fff;
//           transition: all .3s ease;
//         }
//         .info-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 12px 24px rgba(0,0,0,.15);
//         }


//       `}</style>
//     </div>
//   );
// }



import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import { Target, Award, GraduationCap, Users, ChevronDown } from 'lucide-react';

const MedicalEducation = () => {
  const [expanded, setExpanded] = useState(null);

  const toggleExpand = (category) => {
    setExpanded(expanded === category ? null : category);
  };

  const programStructure = {
    MS: {
      description:
        'Master of Surgery (MS) programs focus on advanced surgical expertise with rigorous clinical training and hands-on operative exposure.',
      items: [
        { title: 'Cardiac Surgery', body: 'Residents learn complex surgeries such as bypass grafting and valve replacement.' },
        { title: 'Anaesthesia', body: 'Strong foundation in safe and effective anesthesia care across specialties.' },
      ],
    },
    MD: {
      description:
        'Doctor of Medicine (MD) programs provide specialized training in clinical fields to prepare physicians for leadership.',
      items: [
        { title: 'Cardiology', body: 'Cardiology is the branch of medicine focused on diagnosing and treating diseases of the heart and blood vessels. Residents at Rawalpindi Institute of Cardiology are trained to manage a wide spectrum of cardiovascular conditions, from heart failure to arrhythmias. Looking at its importance and massive prevalence , RIC has developed four Cardiology units.  ' },
        { title: 'Pediatric Cardiology', body: 'Pediatric Cardiology focuses on the diagnosis and treatment of congenital and acquired heart diseases in infants, children, and adolescents. Residents are trained to handle the unique challenges of treating young patients with cardiac anomalies.' },
      ],
    },
    Diploma: {
      description:
        'Diploma programs provide focused and practical training in medical specialties for applied clinical practice.',
      items: [
        { title: 'Anaesthesia', body: 'Anaesthesia is the practice of administering medications to induce a reversible state of unconsciousness for surgical procedures. Our residents develop a strong foundation in providing safe and effective anesthesia care across a broad range of medical and surgical specialties.' },
        { title: 'Cardiology', body: 'Cardiology is the branch of medicine focused on diagnosing and treating diseases of the heart and blood vessels. Residents at Rawalpindi Institute of Cardiology are trained to manage a wide spectrum of cardiovascular conditions, from heart failure to arrhythmias. Looking at its importance and massive prevalence , RIC has developed four Cardiology units.  ' },
      ],
    },
    FCPS: {
      description:
        'The Fellowship of College of Physicians and Surgeons (FCPS) program offers comprehensive training across disciplines.',
      items: [
        { title: 'Cardiology', body: 'Cardiology is the branch of medicine focused on diagnosing and treating diseases of the heart and blood vessels. Residents at Rawalpindi Institute of Cardiology are trained to manage a wide spectrum of cardiovascular conditions, from heart failure to arrhythmias. Looking at its importance and massive prevalence , RIC has developed four Cardiology units.  ' },
        { title: 'Cardiac Surgery', body: 'Cardiac Surgery is the field dedicated to operative procedures on the heart and great vessels. Residents learn to perform complex surgeries such as bypass grafting and valve replacement to correct severe cardiac issues' },
        { title: 'Interventional Cardiology', body: 'Interventional Cardiology is a subspecialty of cardiology that uses catheter-based techniques to treat structural heart diseases. Our residents gain hands-on experience in performing procedures like angioplasty and stenting to restore blood flow to the heart' },
        { title: 'Radiology', body: 'Radiology is the medical specialty that uses imaging techniques like X-rays, CT scans, and MRI to diagnose and treat diseases. At Rawalpindi Institute of Cardiology, residents learn to interpret these images to accurately assess and manage cardiac conditions' },
        { title: 'Pediatric Cardiology', body: 'Pediatric Cardiology focuses on the diagnosis and treatment of congenital and acquired heart diseases in infants, children, and adolescents. Residents are trained to handle the unique challenges of treating young patients with cardiac anomalies.' },
        { title: 'Pediatric Congenital Cardiac Surgery', body: 'Pediatric Congenital Cardiac Surgery involves surgical repair of heart defects in pediatric patients. At Rawalpindi Institute of Cardiology, residents master the delicate techniques required to operate on the tiny hearts of children.' },
        { title: 'Anaesthesia', body: ' Anaesthesia is the practice of administering medications to induce a reversible state of unconsciousness for surgical procedures. Our residents develop a strong foundation in providing safe and effective anesthesia care across a broad range of medical and surgical specialties.' },
      ],
    },
    MCPS: {
      description:
        'Membership of College of Physicians and Surgeons (MCPS) provides focused training in core specialties for independent practice.',
      items: [
        { title: 'Anaesthesia', body: 'Focused program in anesthesia for medical procedures and surgeries.' },
      ],
    },
  };

const IconList = ({ items }) => (
  <ul className="it-custom-list">
    {items.map((item, i) => (
      <li key={i}>
        <i
          className="flaticon-check-mark"
          style={{ color: 'red', fontSize: '18px' }}
        ></i>{' '}
        {item}
      </li>
    ))}
  </ul>
);


  return (
    <main>
      <Breadcrumb title="Medical Education" subTitle="Medical Education" />

      <div className="it-sv-details__area pt-120 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-9 col-lg-9">
              <div className="it-sv-details__left">
                {/* About Section */}
                <h3 className="it-section-title mb-30">About Us</h3>
                <p className="mb-50">
                  The Department of Medical Education at Rawalpindi Institute of Cardiology (RIC) plays a pivotal role in advancing healthcare education, training future medical professionals, and maintaining high standards in academic activities. Affiliated with the College of Physicians and Surgeons Pakistan (CPSP) and the University of Health Sciences (UHS) Lahore, the department oversees postgraduate training across various specialties, in line with the regulations set by the Pakistan Medical and Dental Council (PMDC).
<br></br>
<br></br>
Our mission is to ensure that future specialists are well-equipped to meet the evolving challenges of cardiovascular medicine and surgery—both in Pakistan and internationally—through structured, high-quality education and continuous professional development.
                </p>

                {/* Vision Section */}
                <h3 className="it-section-title mb-30">Our Vision</h3>
                <p className="mb-50">
                  The vision of the Department of Medical Education at RIC is to be a leader in medical education, recognized for its commitment to academic excellence, innovation ( A.I linked), and the development of compassionate healthcare professionals
                </p>

         {/* Mission & Objectives */}
<div className="row mb-50 align-items-stretch">
  <div className="col-md-6 mb-30 d-flex">
    <div className="grey-bg p-4 shadow w-100">
      <Target size={30} className="mb-3 text-success" />
      <h5>Mission & Philosophy</h5>
      <IconList
        items={[
          'Dissemination of clinical knowledge',
          'Evidence-based education',
          'Highly skilled professionals',
          'National & international standards',
          'Organize & supervise Workshops',
        ]}
      />
    </div>
  </div>
  <div className="col-md-6 mb-30 d-flex">
    <div className="grey-bg p-4 shadow w-100">
      <Award size={30} className="mb-3 text-warning" />
      <h5>Objectives</h5>
      <IconList
        items={[
          'Structured postgraduate training',
          'Continuous medical education',
          'Promote research & innovation',
          'Compliance with standards',
          'Promote National Healthcare',
          'Provide hands-on structured postgraduate training',
        ]}
      />
    </div>
  </div>
</div>


                {/* Key Features */}
                <h3 className="mb-30">Key Features</h3>
                <IconList
                  items={[
                    'Postgraduate Training Structure – FCPS, MD, MS, MCPS, and Diploma programs.',
                    'Selection Criteria – Induction through Central Induction Program (CIP/PRP).',
                    'Academic SOPs – Daily sessions, bedside teaching, journal clubs, CPCs, assessments.',
                    'Supervisor Responsibilities – Mentorship and research guidance.',
                    'Assessment & Appraisal – Six-monthly evaluations with feedback.',
                    'Research Requirements – Synopsis, dissertation, mandatory publications (CPSP/UHS).',
                    'Leave & Dress Code Policy – As per SHC&ME and institutional rules.',
                    'Experience Certification – Issued upon training completion.',
                  ]}
                />

                {/* Our Team */}
<h3 className="mb-30 mt-50">Our Team</h3>
<div className="row mb-50">
  <div className="col-md-4 mb-30 d-flex">
    <div className="grey-bg p-4 shadow w-100 h-100 d-flex flex-column align-items-center justify-content-center text-center">
      <Users size={40} className="text-primary mb-3" />
      <h6>Admin Director</h6>
      <p>Dr. Kashif Rauf</p>
       <Users size={40} className="text-primary mb-3" />
      <h6>Clinical Director</h6>
      <p>Dr. Daniyal Kamal</p>
    </div>
    
  </div>
  <div className="col-md-4 mb-30 d-flex">
    <div className="grey-bg p-4 shadow w-100 h-100 d-flex flex-column align-items-center justify-content-center text-center">
      <Users size={40} className="text-success mb-3" />
      <h6>Supervisors & Faculty</h6>
      <p>Professors, Associate Professors, Assistant Professors</p>
    </div>
  </div>
  <div className="col-md-4 mb-30 d-flex">
    <div className="grey-bg p-4 shadow w-100 h-100 d-flex flex-column align-items-center justify-content-center text-center">
      <Users size={40} className="text-warning mb-3" />
      <h6>Support Staff</h6>
      <p>DEO, Junior DEO, Stenographer, Operator, PA</p>
    </div>
  </div>
</div>


               {/* Programs Offered */}
<h3 className="mb-30">Programs Offered</h3>
<div className="accordion mb-50">
  {Object.keys(programStructure).map((category, idx) => (
    <div key={idx} className="accordion-item mb-20">
      {/* Accordion Header */}
      <div
        className={`accordion-header d-flex justify-content-between align-items-center p-3 shadow cursor-pointer ${
          expanded === category ? 'active' : ''
        }`}
        onClick={() => toggleExpand(category)}
      >
        <h5 className="mb-0 d-flex align-items-center">
          <GraduationCap size={22} className="text-primary me-2" />
          {category}
        </h5>
        <ChevronDown
          className={`transition-transform ${expanded === category ? 'rotate-180' : ''}`}
        />
      </div>

      {/* Accordion Body */}
      {expanded === category && (
        <div className="accordion-body p-4 grey-bg animate__animated animate__fadeIn">
          <p className="mb-20">{programStructure[category].description}</p>
          <div className="row">
            {programStructure[category].items.map((item, i) => (
              <div key={i} className="col-md-6 mb-20 d-flex">
                <div className="white-bg shadow p-4 h-100 w-100 transition-all hover-up text-center">
                  <GraduationCap size={28} className="text-primary mb-3" />
                  <h6 className="mb-2">{item.title}</h6>
                  <p className="small text-muted">{item.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  ))}
</div>


                {/* Postgraduate Training */}
                {/* <h3 className="mb-30">Postgraduate Training</h3>
                <IconList
                  items={[
                    'Induction via Central Induction Program (CIP/PRP) of SHC&ME.',
                    'Regular academic sessions, CPCs, workshops, bedside teaching.',
                    'Six-monthly appraisal sessions with feedback.',
                    'Research requirements: Synopsis, Dissertation, Publications.',
                    'Experience certificate as per CPSP/UHS policies.',
                  ]}
                /> */}
              </div>
            </div>

            {/* //       {/* Inline CSS */}
<style>{`

.accordion-header.active {
  background: #f5f7fa;
  border-left: 4px solid var(--it-theme-color, #007bff);
}

.cursor-pointer {
  cursor: pointer;
}

.transition-transform {
  transition: transform 0.3s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}

.hover-up {
  transition: all 0.3s ease;
}
.hover-up:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}


.it-custom-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.it-custom-list li {
  position: relative;
  padding-left: 28px; /* space for the icon */
  margin-bottom: 10px;
}

.it-custom-list li i {
  position: absolute;
  left: 0;
  top: 4px;
  color: var(--it-theme-color, #28a745); /* adjust to your theme’s primary color */
  font-size: 14px;
}

.sidebar-widget{
padding:41px 20px;
}


.sidebar-widget-list a {
 
  transition: all 0.3s ease;
}

.sidebar-widget-list a:hover {
  background-color: var(--it-theme-color, #ee344e); /* use your theme’s primary */
  color: #fff;
  padding-left: 18px; /* subtle slide effect */
}


.sidebar-widget-title{
font-size:28px;
}

  `}</style>
                    
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-3 mb-50">
              <div className="it-sv-details__right">
                <div className="sidebar-wrap mb-60 p-relative">
                  <div className="sidebar-widget mb-45">
                    <h4 className="sidebar-widget-title mb-35">Quick Links</h4>
                    <div className="sidebar-widget-list">
                      <Link to="../certificates">Certifications</Link>
                      <Link to="../team">Our Doctors</Link>
                      <Link to="../event">Our Events</Link>
                      <Link to="../contact">Contact Us</Link>
                    </div>
                  </div>
                  <div className="sidebar-widget mb-45">
                    <h4 className="sidebar-widget-title mb-35">Contact Us</h4>
                    <p>Medical Education Department</p>
                    <p>Rawalpindi Institute of Cardiology</p>
                    <p>Phone: 0519281374</p>
                    <p>Email: amsmedicaleducation@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default MedicalEducation;
